import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export const getAdvDataReducer = (
  state: CustomerState,
  action: PayloadAction<any | undefined>,
) => {
  state.advQuestions = action.payload;
};
